module.exports = __webpack_public_path__ + "static/img/loading.94094d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.jpg
// module id = xOur
// module chunks = 1